<ng-template #nameCell let-meeting>
  <span [class.soft-deleted]="meeting.markedToBeDeletedAt !== null" [matTooltip]="softDeletionNote(meeting)">{{ meeting.name }}</span>
</ng-template>

<ng-template #meetingOwnersCell let-meeting>
  @if (meeting.users.length > 0) {
    <div class="user-avatar-list">
      @for (user of meeting.users; track user.userId) {
        <app-avatar [input]="user.firstName + ' ' + user.lastName" size="small" [matTooltip]="user.firstName + ' ' + user.lastName"></app-avatar>
      }
    </div>
  } @else {
    -
  }
</ng-template>

<ng-template #softDeletionCell let-meeting>
  @let deletion = softDeletionOf(meeting);
  <span class="deletion-date" [class.happened]="deletion.hasHappened" [matTooltip]="deletion.note">{{ deletion.label }}</span>
</ng-template>

<ng-template #hardDeletionCell let-meeting>
  @let deletion = hardDeletionOf(meeting);
  <span class="deletion-date" [class.happened]="deletion.hasHappened" [matTooltip]="deletion.note">{{ deletion.label }}</span>
</ng-template>

<div class="page-container">
  <app-toolbar [title]="'COMMON.MEETINGS' | translate"></app-toolbar>

  <div class="page">
    <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectTab($event)" mat-stretch-tabs="false" animationDuration="0ms">
      <mat-tab [label]="'ADMIN.MEETINGS.TABS.ACTIVE' | translate">
        <div class="panel">
          <app-table
            [source]="source"
            [columns]="columns"
            [rowId]="rowId"
            [rowActions]="rowActions"
            [pageSize]="defaultPageSize"
            [defaultSort]="defaultSort"
            [selectable]="false"
            [syncUrl]="true"
            tableId="admin-meetings"
            label="COMMON.MEETINGS"
            rowNoun="ADMIN.MEETINGS.MEETING"
            rowNounPlural="ADMIN.MEETINGS.MEETINGS"
            csvFilename="meetings"
            (rowActionTriggered)="handleRowAction($event)"
          />
        </div>
      </mat-tab>
      <mat-tab [label]="'ADMIN.MEETINGS.TABS.DELETED' | translate">
        <ng-template matTabContent>
          <div class="panel">
            <p class="tab-description" translate="ADMIN.MEETINGS.DELETED_DESCRIPTION"></p>
            <app-table
              [source]="deletedSource"
              [columns]="deletedColumns"
              [rowId]="deletedRowId"
              [pageSize]="defaultPageSize"
              [defaultSort]="deletedDefaultSort"
              [selectable]="false"
              [syncUrl]="true"
              urlPrefix="deleted"
              tableId="admin-deleted-meetings"
              label="ADMIN.MEETINGS.TABS.DELETED"
              rowNoun="ADMIN.MEETINGS.DELETED_MEETING"
              rowNounPlural="ADMIN.MEETINGS.DELETED_MEETINGS"
              csvFilename="hard-deleted-meetings"
            />
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
